var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"92cf0a906f26de8bef5b1b25b7d8ff77a9bd6944"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lacinetek-frontend@codekraft-ka"]={id:"92cf0a906f26de8bef5b1b25b7d8ff77a9bd6944"};
      